/**
 * 模組 → 圖示(boxicons)的單一來源。
 *
 * Figma DCK-00 註記「其餘相關模組樣式參考,統一跟選單icon一樣」:
 * 側欄選單(15:848)與通知圖示必須同一組,所以兩邊都從這裡取,
 * 不要各自寫死 class —— 一致性由結構保證,不是靠測試盯著。
 */
export const MODULE_ICON = {
  智慧看板: "bx-grid-alt",
  人員管理: "bx-user",
  機房管理: "bx-buildings",
  營運資訊: "bx-briefcase",
  資產管理: "bx-server",
  監控派工: "bx-collection",
  訊息功能: "bx-bell",
  報表功能: "bx-bar-chart-alt-2",
  決策分析: "bx-bulb",
  審核中心: "bx-check-shield",
};

/** 側欄沒有對應項、但通知會用到的圖示 */
export const EXTRA_ICON = {
  審核訊息: MODULE_ICON.審核中心, // 審核相關通知沿用審核中心圖示
  批次匯入: "bx-file",           // 側欄無此項 → 文件圖示(設計稿參考圖)
};

/**
 * 外框 → 實心(boxicons solid)對照。
 *
 * 側欄是深底細線圖示用外框版;notice 是藍色圓底 + 白色字符,設計稿指定實心版
 * (bxs-check-shield / bxs-file-blank / bxs-user),小尺寸下才看得清楚。
 * 名稱不是一律加 s(bx-file → bxs-file-blank),所以明列而不是字串拼接。
 */
export const SOLID_OF = {
  "bx-grid-alt": "bxs-grid-alt",
  "bx-user": "bxs-user",
  "bx-buildings": "bxs-buildings",
  "bx-briefcase": "bxs-briefcase",
  "bx-server": "bxs-server",
  "bx-collection": "bxs-collection",
  "bx-bell": "bxs-bell",
  "bx-bar-chart-alt-2": "bxs-bar-chart-alt-2",
  "bx-bulb": "bxs-bulb",
  "bx-check-shield": "bxs-check-shield",
  "bx-file": "bxs-file-blank",
};

/** 取實心版;沒有對照就退回原本的外框版 */
export const toSolid = (icon) => SOLID_OF[icon] || icon;

export default MODULE_ICON;
